var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_5790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.502 27.8157C10.8901 28.2304 10.1749 28.4667 9.43631 28.4981C8.57616 28.4825 7.75364 28.1425 7.13347 27.5463C6.5133 26.9501 6.14126 26.1416 6.0918 25.2827L9.55926 23.2231L14.9388 25.6331L11.502 27.8157Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5488 18.95L10.979 17.8188C9.82929 17.3147 8.74724 16.8782 8.74724 15.6178C8.73025 15.3723 8.7665 15.1259 8.85351 14.8957C8.94052 14.6654 9.07624 14.4566 9.25138 14.2837L14.6801 16.6691L13.346 17.4561C12.9709 17.6774 12.7312 17.8803 12.7312 18.1692C12.7312 18.4582 13.0816 18.741 13.5673 18.95H13.5488Z",
    fill: "#96CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0702 7.09081L13.4327 8.69543C13.1991 8.83683 12.8794 9.05817 12.8794 9.41475C12.8794 9.77134 13.4942 10.1156 14.0291 10.3738L10.7399 8.9229C9.77465 8.49254 8.79712 8.01301 8.79712 6.83874C8.79052 6.40067 8.91935 5.97124 9.166 5.60914L16.2977 1.25635C16.7968 1.53079 17.2145 1.93243 17.5082 2.4205C17.8019 2.90858 17.9612 3.46569 17.9699 4.03525C17.9742 4.67441 17.7983 5.30183 17.4623 5.84554C17.1263 6.38926 16.6438 6.82725 16.0702 7.10925V7.09081Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6704 12.2305L21.0187 12.6056L15.5654 10.2017L21.8979 6.38379C22.3985 6.65978 22.818 7.06216 23.1147 7.55082C23.4113 8.03948 23.5747 8.59735 23.5886 9.16883C23.5987 9.8115 23.4231 10.4434 23.0828 10.9887C22.7426 11.534 22.2521 11.9695 21.6704 12.2428V12.2305Z",
    fill: "#96CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0662 16.8657L20.2939 18.2798C21.5235 18.8208 21.874 19.4602 21.874 20.2594C21.8633 20.496 21.8031 20.7277 21.6972 20.9395C21.5913 21.1513 21.442 21.3385 21.2592 21.489L15.8428 19.079L16.7527 18.5749C17.5273 18.1384 17.7917 17.8863 17.7917 17.6035C17.7917 17.3207 17.6011 17.1178 17.0724 16.8719L17.0662 16.8657Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8269 28.7499C21.3925 27.7157 19.8405 26.8552 18.2036 26.1862L10.0022 22.5404C7.93643 21.6182 6.56543 20.4009 6.56543 18.3352C6.56543 16.2695 7.53682 15.3596 8.79716 14.5604L9.2521 14.2837C9.07696 14.4566 8.94124 14.6654 8.85423 14.8957C8.76722 15.1259 8.73097 15.3723 8.74796 15.6178C8.74796 16.8782 9.83001 17.3147 10.9797 17.8188L20.5214 22.024C22.1937 22.7433 23.7061 23.9729 23.7061 26.051C23.7267 27.0242 23.4168 27.9756 22.8269 28.7499Z",
    fill: "#4C9847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8426 21.1081L21.2278 21.4831C21.4107 21.3326 21.5599 21.1454 21.6658 20.9336C21.7717 20.7218 21.8319 20.4901 21.8426 20.2535C21.8426 19.4543 21.4675 18.8149 20.2625 18.2739L10.0569 13.792C7.99112 12.8636 6.7062 11.6894 6.7062 9.63592C6.69945 8.80424 6.92266 7.98687 7.35121 7.27408C7.77976 6.56128 8.39695 5.98078 9.13465 5.59668C8.888 5.95878 8.75917 6.38821 8.76577 6.82628C8.76577 8.00055 9.7433 8.4801 10.7085 8.91046L20.6253 13.2878C22.4389 14.0932 23.9022 15.3105 23.9022 17.4992C23.9231 18.2339 23.7386 18.9598 23.3693 19.5952C22.9999 20.2307 22.4606 20.7504 21.8118 21.0958L21.8426 21.1081Z",
    fill: "#296085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_5790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8538,
    height: 27.5,
    fill: "white",
    transform: "translate(6.07324 1.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc30);
export default __webpack_public_path__ + "static/media/SC제일-30.2042a06bd10c788394de9ca7a2f7615a.svg";
export { ForwardRef as ReactComponent };